const getCompanyConfig = () => {
	const bluepearDetails = {
		name: 'Nazwa Firmy ABC',
		address: '12-123 Miasto, Adres 123, Polska',
		website: 'https://firma.com',
		isLite: false,
		isNettoBruttoEnabled: true, // if enabled user can select "brutto" or "netto", if disabled than "brutto" is set
		isCommissionFieldVisible: false,
		isMultiCurrencyEnabled: true, // if enabled user can choose currency
		canNonAdminSeeRouteAsAdmin: false,
		canNonAdminSeeTopButtons: false,
		canChangeStartPoint: true,
		agentsCanEditEverything: true,
		agentsCanSeeRouteTotals: true,
		shouldPDFRouteViewIncludeMap: true,
		shouldDOCRouteViewIncludeMap: true,
		isRouteProductionPdfAvailable: true,
		isStateFieldEnabled: false,
		isInProductionStatusEnabled: false,
		isFilterByCountryEnabled: true,
		canDuplicateOrder: true,
		perPageOptions: [5, 10, 25, 50, 100, 200, 350, 500],
		canSendAsUser: true,
		canSendWithGmail: true,
		canSortByCreatedDate: true,
		isSystemMailerOptionVisible: true,
		canMoveToTrash: true,
		canMoveToComplaints: true,
		orderStatusNames: {
			new: 'NOWE',
			pending: 'OCZEKUJĄCE',
			planned: 'PLANOWANE',
			inProduction: 'PRODUKCJA',
			sent: 'WYSŁANE',
			archived: 'ARCHIWUM',
			trashed: 'KOSZ',
			complaint: 'REKLAMACJA',
			all: 'WSZYSTKIE'
		},
		orderPriceLabel: 'Cena',
		systemEmail: 'test@bluepear.pl'
	}

	const bluepearLiteDetails = {
		name: 'Nazwa Firmy ABC',
		address: '12-123 Miasto, Adres 123, Polska',
		website: 'https://firma.com',
		isLite: true,
		isNettoBruttoEnabled: true, // if enabled user can select "brutto" or "netto", if disabled than "brutto" is set
		isCommissionFieldVisible: false,
		isMultiCurrencyEnabled: true, // if enabled user can choose currency
		canNonAdminSeeRouteAsAdmin: false,
		canNonAdminSeeTopButtons: false,
		canChangeStartPoint: false,
		agentsCanEditEverything: true,
		agentsCanSeeRouteTotals: true,
		shouldPDFRouteViewIncludeMap: false,
		shouldDOCRouteViewIncludeMap: false,
		isRouteProductionPdfAvailable: false,
		isStateFieldEnabled: true,
		isInProductionStatusEnabled: false,
		isFilterByCountryEnabled: false,
		canDuplicateOrder: false,
		perPageOptions: [5, 10, 25, 50],
		canSendAsUser: false,
		canSendWithGmail: false,
		canSortByCreatedDate: false,
		isSystemMailerOptionVisible: true,
		canMoveToTrash: false,
		canMoveToComplaints: false,
		orderStatusNames: {
			new: 'NOWE',
			pending: 'OCZEKUJĄCE',
			planned: 'PLANOWANE',
			inProduction: 'PRODUKCJA',
			sent: 'WYSŁANE',
			archived: 'ARCHIWUM',
			trashed: 'KOSZ',
			complaint: 'REKLAMACJA',
			all: 'WSZYSTKIE'
		},
		orderPriceLabel: 'Cena',
		systemEmail: 'test@bluepear.pl'
	}

	const tabservisDetails = {
		name: 'Mariusz Tabak TAB SERVISS',
		address: '34-620 Jodlownik, SLUPIA 100, POLSKO',
		website: 'https://tabserviss.cz',
		isLite: false,
		isNettoBruttoEnabled: true,
		isCommissionFieldVisible: true,
		isMultiCurrencyEnabled: true,
		canNonAdminSeeRouteAsAdmin: false,
		canNonAdminSeeTopButtons: false,
		canChangeStartPoint: false,
		agentsCanEditEverything: true,
		agentsCanSeeRouteTotals: false,
		shouldPDFRouteViewIncludeMap: false,
		shouldDOCRouteViewIncludeMap: false,
		isRouteProductionPdfAvailable: true,
		isStateFieldEnabled: false,
		isInProductionStatusEnabled: true,
		isFilterByCountryEnabled: true,
		canDuplicateOrder: true,
		perPageOptions: [5, 10, 25, 50, 100, 200, 350, 500],
		canSendAsUser: true,
		canSendWithGmail: true,
		canSortByCreatedDate: true,
		isSystemMailerOptionVisible: false,
		canMoveToTrash: false,
		canMoveToComplaints: false,
		orderStatusNames: {
			new: 'NOWE',
			pending: 'OCZEKUJĄCE',
			planned: 'PLANOWANE',
			inProduction: 'PRODUKCJA',
			sent: 'WYSŁANE',
			archived: 'ARCHIWUM',
			trashed: 'KOSZ',
			complaint: 'REKLAMACJA',
			all: 'WSZYSTKIE'
		},
		orderPriceLabel: 'Do zapłaty',
		systemEmail: 'tabserviss@tabserviss.cz'
	}

	const modneGarazeDetails = {
		name: 'Oryginalne Garaże Michał Sewiło',
		address: 'Sadek 130, 34-620 Jodłownik, Polska',
		// website: 'https://firma.com',
		isLite: false,
		isNettoBruttoEnabled: false, // if enabled user can select "brutto" or "netto", if disabled than "brutto" is set
		isCommissionFieldVisible: false,
		isMultiCurrencyEnabled: false, // if enabled user can choose currency
		canNonAdminSeeRouteAsAdmin: true,
		canNonAdminSeeTopButtons: false,
		canChangeStartPoint: true,
		agentsCanEditEverything: true,
		agentsCanSeeRouteTotals: true,
		shouldPDFRouteViewIncludeMap: true,
		shouldDOCRouteViewIncludeMap: true,
		isRouteProductionPdfAvailable: true,
		isStateFieldEnabled: true,
		isInProductionStatusEnabled: false,
		isFilterByCountryEnabled: false,
		canDuplicateOrder: false,
		perPageOptions: [5, 10, 25, 50, 100],
		canSendAsUser: false,
		canSendWithGmail: false,
		canSortByCreatedDate: false,
		isSystemMailerOptionVisible: true,
		canMoveToTrash: false,
		canMoveToComplaints: false,
		orderStatusNames: {
			new: 'NOWE',
			pending: 'OCZEKUJĄCE',
			planned: 'PLANOWANE',
			inProduction: 'PRODUKCJA',
			sent: 'WYSŁANE',
			archived: 'ARCHIWUM',
			trashed: 'KOSZ',
			complaint: 'REKLAMACJA',
			all: 'WSZYSTKIE'
		},
		orderPriceLabel: 'Cena'
	}

	const blachTransDetails = {
		name: 'Blach-Trans Paweł Sroka',
		address: 'Tarnawa 4 32-741 Tarnawa, NIP: 8681896064',
		website: 'https://blachtrans.com',
		isLite: false,
		isNettoBruttoEnabled: true, // if enabled user can select "brutto" or "netto", if disabled than "brutto" is set
		isCommissionFieldVisible: false,
		isMultiCurrencyEnabled: true, // if enabled user can choose currency
		canNonAdminSeeRouteAsAdmin: false,
		canNonAdminSeeTopButtons: true,
		canChangeStartPoint: true,
		agentsCanEditEverything: true,
		agentsCanSeeRouteTotals: true,
		shouldPDFRouteViewIncludeMap: true,
		shouldDOCRouteViewIncludeMap: true,
		isRouteProductionPdfAvailable: true,
		isStateFieldEnabled: true,
		isInProductionStatusEnabled: false,
		isFilterByCountryEnabled: false,
		canDuplicateOrder: false,
		perPageOptions: [5, 10, 25, 50, 100, 200, 350],
		canSendAsUser: true,
		canSendWithGmail: true,
		canSortByCreatedDate: true,
		isSystemMailerOptionVisible: true,
		canMoveToTrash: false,
		canMoveToComplaints: false,
		orderStatusNames: {
			new: 'NOWE',
			pending: 'OCZEKUJĄCE',
			planned: 'PLANOWANE',
			inProduction: 'PRODUKCJA',
			sent: 'WYSŁANE',
			archived: 'ARCHIWUM',
			trashed: 'KOSZ',
			complaint: 'REKLAMACJA',
			all: 'WSZYSTKIE'
		},
		orderPriceLabel: 'Cena',
		systemEmail: 'mailer@bluepear.pl'
	}

	const benstalDetails = {
		name: 'F.P.H.U "BEN-STAL" Galica Beniamin',
		address: 'Przenosza 102, 34-625 Skrzydlna',
		website: 'https://benstal.pl',
		isLite: false,
		isNettoBruttoEnabled: true, // if enabled user can select "brutto" or "netto", if disabled than "brutto" is set
		isCommissionFieldVisible: false,
		isMultiCurrencyEnabled: true, // if enabled user can choose currency
		canNonAdminSeeRouteAsAdmin: false,
		canNonAdminSeeTopButtons: false,
		canChangeStartPoint: false,
		agentsCanEditEverything: true,
		agentsCanSeeRouteTotals: true,
		shouldPDFRouteViewIncludeMap: true,
		shouldDOCRouteViewIncludeMap: false,
		appSubPathname: 'panel',
		isRouteProductionPdfAvailable: true,
		isStateFieldEnabled: true,
		isInProductionStatusEnabled: false,
		isFilterByCountryEnabled: false,
		canDuplicateOrder: false,
		perPageOptions: [5, 10, 25, 50, 100, 200],
		canSendAsUser: false,
		canSendWithGmail: false,
		canSortByCreatedDate: false,
		isSystemMailerOptionVisible: true,
		canMoveToTrash: true,
		canMoveToComplaints: true,
		orderStatusNames: {
			new: 'NOWE',
			pending: 'OCZEKUJĄCE',
			planned: 'PLANOWANE',
			inProduction: 'PRODUKCJA',
			sent: 'WYSŁANE',
			archived: 'ARCHIWUM',
			trashed: 'KOSZ',
			complaint: 'REKLAMACJA',
			all: 'WSZYSTKIE'
		},
		orderPriceLabel: 'Cena'
	}

	const dgwentDetails = {
		name: 'DG WENT Mariusz Dziedzic',
		address: 'Krasne Lasocice 92, 34-620 Jodłownik',
		website: 'https://dgwent.com.pl',
		isLite: false,
		isNettoBruttoEnabled: true, // if enabled user can select "brutto" or "netto", if disabled than "brutto" is set
		isCommissionFieldVisible: false,
		isMultiCurrencyEnabled: true, // if enabled user can choose currency
		canNonAdminSeeRouteAsAdmin: false,
		canNonAdminSeeTopButtons: false,
		canChangeStartPoint: false,
		agentsCanEditEverything: true,
		agentsCanSeeRouteTotals: true,
		shouldPDFRouteViewIncludeMap: true,
		shouldDOCRouteViewIncludeMap: false,
		isRouteProductionPdfAvailable: true,
		isStateFieldEnabled: true,
		isInProductionStatusEnabled: false,
		isFilterByCountryEnabled: false,
		canDuplicateOrder: false,
		perPageOptions: [5, 10, 25, 50, 100],
		canSendAsUser: false,
		canSendWithGmail: false,
		canSortByCreatedDate: false,
		isSystemMailerOptionVisible: true,
		canMoveToTrash: false,
		canMoveToComplaints: false,
		orderStatusNames: {
			new: 'NOWE',
			pending: 'OCZEKUJĄCE',
			planned: 'PLANOWANE',
			inProduction: 'PRODUKCJA',
			sent: 'WYSŁANE',
			archived: 'ARCHIWUM',
			trashed: 'KOSZ',
			complaint: 'REKLAMACJA',
			all: 'WSZYSTKIE'
		},
		orderPriceLabel: 'Cena'
	}

	const robstalDetails = {
		name: 'FPHU ROBERT KURNIK',
		address: '34-620 Krasne – Lasocice 110, NIP: 737-177-76-20',
		website: 'https://trasy-robstal.bluepear.pl',
		isLite: false,
		isNettoBruttoEnabled: true, // if enabled user can select "brutto" or "netto", if disabled than "brutto" is set
		isCommissionFieldVisible: true,
		isMultiCurrencyEnabled: true, // if enabled user can choose currency
		canNonAdminSeeRouteAsAdmin: false,
		canNonAdminSeeTopButtons: false,
		canChangeStartPoint: true,
		agentsCanEditEverything: true,
		agentsCanSeeRouteTotals: true,
		shouldPDFRouteViewIncludeMap: true,
		shouldDOCRouteViewIncludeMap: true,
		isRouteProductionPdfAvailable: true,
		isStateFieldEnabled: true,
		isInProductionStatusEnabled: false,
		isFilterByCountryEnabled: false,
		canDuplicateOrder: false,
		perPageOptions: [5, 10, 25, 50, 100],
		canSendAsUser: false,
		canSendWithGmail: false,
		canSortByCreatedDate: false,
		isSystemMailerOptionVisible: true,
		canMoveToTrash: false,
		canMoveToComplaints: false,
		orderStatusNames: {
			new: 'NOWE',
			pending: 'OCZEKUJĄCE',
			planned: 'PLANOWANE',
			inProduction: 'PRODUKCJA',
			sent: 'WYSŁANE',
			archived: 'ARCHIWUM',
			trashed: 'KOSZ',
			complaint: 'REKLAMACJA',
			all: 'WSZYSTKIE'
		},
		orderPriceLabel: 'Cena'
	}

	const agrolDetails = {
		name: 'FHU AGROL',
		address: 'Oblekoń 156A, 28-133 Pacanów',
		website: 'https://system.agrolsklep.pl',
		isLite: false,
		isNettoBruttoEnabled: true, // if enabled user can select "brutto" or "netto", if disabled than "brutto" is set
		isCommissionFieldVisible: true,
		isMultiCurrencyEnabled: true, // if enabled user can choose currency
		canNonAdminSeeRouteAsAdmin: false,
		canNonAdminSeeTopButtons: false,
		canChangeStartPoint: true,
		agentsCanEditEverything: true,
		agentsCanSeeRouteTotals: true,
		shouldPDFRouteViewIncludeMap: true,
		shouldDOCRouteViewIncludeMap: true,
		isRouteProductionPdfAvailable: true,
		isStateFieldEnabled: true,
		isInProductionStatusEnabled: false,
		isFilterByCountryEnabled: false,
		canDuplicateOrder: false,
		perPageOptions: [5, 10, 25, 50, 100],
		canSendAsUser: false,
		canSendWithGmail: false,
		canSortByCreatedDate: false,
		isSystemMailerOptionVisible: true,
		canMoveToTrash: false,
		canMoveToComplaints: false,
		orderStatusNames: {
			new: 'NOWE',
			pending: 'OCZEKUJĄCE',
			planned: 'PLANOWANE',
			inProduction: 'PRODUKCJA',
			sent: 'WYSŁANE',
			archived: 'ARCHIWUM',
			trashed: 'KOSZ',
			complaint: 'REKLAMACJA',
			all: 'WSZYSTKIE'
		},
		orderPriceLabel: 'Cena'
	}

	const kastalDetails = {
		name: 'KASTAL Damian Kalicki',
		address: 'Jodłownik 220, 34-620 Jodłownik',
		website: 'https://garaze-kastal.pl',
		isLite: true,
		isNettoBruttoEnabled: true, // if enabled user can select "brutto" or "netto", if disabled than "brutto" is set
		isCommissionFieldVisible: false,
		isMultiCurrencyEnabled: true, // if enabled user can choose currency
		canNonAdminSeeRouteAsAdmin: false,
		canNonAdminSeeTopButtons: false,
		canChangeStartPoint: false,
		agentsCanEditEverything: true,
		agentsCanSeeRouteTotals: true,
		shouldPDFRouteViewIncludeMap: false,
		shouldDOCRouteViewIncludeMap: false,
		isRouteProductionPdfAvailable: false,
		isStateFieldEnabled: true,
		isInProductionStatusEnabled: false,
		isFilterByCountryEnabled: false,
		canDuplicateOrder: false,
		perPageOptions: [5, 10, 25, 50],
		canSendAsUser: false,
		canSendWithGmail: false,
		canSortByCreatedDate: false,
		isSystemMailerOptionVisible: true,
		canMoveToTrash: false,
		canMoveToComplaints: false,
		orderStatusNames: {
			new: 'NOWE',
			pending: 'OCZEKUJĄCE',
			planned: 'PLANOWANE',
			inProduction: 'PRODUKCJA',
			sent: 'WYSŁANE',
			archived: 'ARCHIWUM',
			trashed: 'KOSZ',
			complaint: 'REKLAMACJA',
			all: 'WSZYSTKIE'
		},
		orderPriceLabel: 'Cena',
		systemEmail: 'test@bluepear.pl'
	}

	const sylwexDetails = {
		name: 'Sylwex',
		address: 'Polska',
		website: 'https://sylwex.ue',
		isLite: false,
		isNettoBruttoEnabled: true, // if enabled user can select "brutto" or "netto", if disabled than "brutto" is set
		isCommissionFieldVisible: false,
		isMultiCurrencyEnabled: true, // if enabled user can choose currency
		canNonAdminSeeRouteAsAdmin: false,
		canNonAdminSeeTopButtons: false,
		canChangeStartPoint: true,
		agentsCanEditEverything: true,
		agentsCanSeeRouteTotals: true,
		shouldPDFRouteViewIncludeMap: true,
		shouldDOCRouteViewIncludeMap: true,
		isRouteProductionPdfAvailable: true,
		isStateFieldEnabled: true,
		isInProductionStatusEnabled: false,
		isFilterByCountryEnabled: false,
		canDuplicateOrder: false,
		perPageOptions: [5, 10, 25, 50, 100],
		canSendAsUser: true,
		canSendWithGmail: true,
		canSortByCreatedDate: true,
		isSystemMailerOptionVisible: true,
		canMoveToTrash: false,
		canMoveToComplaints: false,
		orderStatusNames: {
			new: 'NOWE',
			pending: 'OCZEKUJĄCE',
			planned: 'PLANOWANE',
			inProduction: 'PRODUKCJA',
			sent: 'WYSŁANE',
			archived: 'ARCHIWUM',
			trashed: 'KOSZ',
			complaint: 'REKLAMACJA',
			all: 'WSZYSTKIE'
		},
		orderPriceLabel: 'Cena',
		systemEmail: 'mailer@bluepear.pl'
	}

	switch (location.hostname) {
		case 'routes-planner.tabserviss.cz':
			return tabservisDetails
		case 'trasy.modnegaraze.pl':
			return modneGarazeDetails
		case 'orders.blachtrans.com':
			return blachTransDetails
		case 'trasy-robstal.bluepear.pl':
			return robstalDetails
		case 'system.agrolsklep.pl':
			return agrolDetails
		case 'routes-planner.bluepear.pl':
			return bluepearDetails
		case 'rp-lite.bluepear.pl':
			return bluepearLiteDetails
		case 'benstal.pl':
			return benstalDetails
		case 'crm.dgwent.com.pl':
			return dgwentDetails
		case 'trasy.garaze-kastal.pl':
			return kastalDetails
		case 'trasy.sylwex.eu':
			return sylwexDetails
		case 'localhost':
			return benstalDetails
	}
}

export default {
	service: {
		baseURL: process.env.VUE_APP_BASE_URL,
		apiRootURL: process.env.VUE_APP_API_ROOT_URL,
		apiURL: process.env.VUE_APP_API_URL,
		orderPdfURL: process.env.VUE_APP_ORDER_PDF_URL,
		routePdfURL: process.env.VUE_APP_ROUTE_PDF_URL,
		routeMapPdfURL: process.env.VUE_APP_ROUTE_MAP_PDF_URL,
		routeMapDocURL: process.env.VUE_APP_ROUTE_MAP_DOC_URL,
		routeProductionPdfURL: process.env.VUE_APP_ROUTE_PRODUCTION_PDF_URL,
		orderDocURL: process.env.VUE_APP_ORDER_DOC_URL,
		routeDocURL: process.env.VUE_APP_ROUTE_DOC_URL
	},
	company: getCompanyConfig(),
	mapboxAccessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN
}
